import { useEffect, useState } from "react";

import styles from "./SupportView.module.css";

import BoardListView from "../common/BoardListView";
import { useModal } from "../modal/Modal";
import ModalButtons from "../modal/ModalButtons";
import DataProvider from "../../data_provider/DataProvider";

import reqFaqViewData from "../../dummy/process=view";

interface SupporContentViewtProps {
    postNo?: number;
    changePageMode: (asis: string, tobe: "main" | "list" | "view") => void;
}

/**
 * @author khy, smyun
 * @date 2022-08-24 14:11, 2025-05-20
 * @remark 지원문의 화면_ 개별 글
 * @param SupportMainProps
 * postNo: 선택된 게시글 번호
 * changePageMode : PageMode 변경 시 부모 컴포넌트에게 변경되는 모드 전달
 * @returns SupportView
 */

function SupportView(props: SupporContentViewtProps) {
    const [faqData, setFaqData] = useState<object>(); // FAQView response
    const { ModalComponent, openModal, closeModal } = useModal();

    useEffect(() => {
        if (props.postNo !== 0) {
            reqFAQView();
        }
    }, [props.postNo]);

    const reqFAQView = async () => {
        try {
            const response = await DataProvider.GetFAQView({
                id: String(props.postNo),
            });

            // 결과 전달
            if (response.flag) {
                setFaqData(response.result);
            } else {
                setFaqData({});
                showModal("게시글이 없습니다.");
            }
        } catch (error) {
            setFaqData({});
            console.error("FAQ목록 조회에 실패하였습니다.", error);
        }
    };

    const showModal = (message: string) => {
        openModal({
            title: "안내",
            children: message,
            modalButtons: (
                <ModalButtons
                    buttonCount={1}
                    buttons={[
                        {
                            label: "확인",
                            color: "Primary",
                            onClick: () => {
                                closeModal();
                                props.changePageMode("view", "main"); // 페이지 이동
                            },
                        },
                    ]}
                />
            ),
        });
    };

    const renderFaqView = (item: any) => {
        if (item) {
            return (
                <div className={styles.wrapper}>
                    <div className={`${styles.title} ${styles.title}`}>{item.TITLE}</div>
                    <div className={styles.content} dangerouslySetInnerHTML={{ __html: item.CONTENTS }}></div>
                </div>
            );
        }
    };

    return (
        <>
            <ModalComponent />
            <BoardListView data={faqData} renderItem={renderFaqView} padding={"10px 10px 60px 10px"} />
        </>
    );
}

SupportView.defaultProps = {
    margin: "0 auto",
    padding: "10px 0px",
    background: "white",
};

export default SupportView;
